import React, { useRef } from "react";
import MasterLayout from "../otherImages/MasterLayout";
import DefaultTopBar from "../components/DefaultTopBar";
import { useDispatch, useSelector } from "react-redux";
import { downloadAssessmentsCSV, clearDocumentState } from "../redux/slices/documentSlice";
import ClientDocumentsData from "../components/ClientDocumentsData";
import Toast from "../components/Toast";

const ClientDocuments = () => {
  const dispatch = useDispatch();

  const documentRef = useRef();

  // Get download states from Redux
  const { isDownloadingCSV, downloadCSVError, successMessage } = useSelector(
    (state) => state.document
  );

  const handleDownloadCSV = () => {
    // Get the local time difference in hours (offset from UTC)
    const localTimeDifference = -new Date().getTimezoneOffset() / 60;

    if (documentRef.current) {
      const filterParams = documentRef.current.getFilterParams();
      // Add the local_time_difference to the params
      const paramsWithTimeZone = {
        ...filterParams,
        local_time_difference: localTimeDifference,
      };
      dispatch(downloadAssessmentsCSV(paramsWithTimeZone));
    } else {
      dispatch(
        downloadAssessmentsCSV({
          local_time_difference: localTimeDifference,
        }),
      );
    }
  };

  return (
    <>
      {/* If you have a Toast component for error messages */}
      {downloadCSVError && (
        <Toast
          show={!!downloadCSVError}
          message={downloadCSVError}
          type="error"
          onClose={() => dispatch(clearDocumentState())}
          duration={3000}
        />
      )}

      <MasterLayout>
        <DefaultTopBar
          title="Documents Management"
          btnText2="Download CSV"
          btnLink2="#"
          isApiButton2={true}
          onBtn2Click={handleDownloadCSV}
          isBtn2Loading={isDownloadingCSV}
          btn2LoadingText="Downloading..."
        />

        <ClientDocumentsData ref={documentRef} />
      </MasterLayout>
    </>
  );
};

export default ClientDocuments;
